import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from '../GridCellBase';

const GLCodeLabelCell = (props: GridCellProps) => {
  const { dataItem } = props;
  return <GridCellBase {...props}>{`GL Code : ${dataItem?.glCd}`}</GridCellBase>;
};

export default GLCodeLabelCell;
